import React, { forwardRef } from "react";
import { Toast } from "@volt_developers/react-ui-components";
import { SnackbarContent } from "notistack";

// TODO: export type from react-ui-components
type Type = "action" | "success" | "error";

export const Snackbar = forwardRef<
  HTMLDivElement,
  { message: string; type?: Type }
>(({ message, type }, ref) => {
  return (
    <SnackbarContent ref={ref}>
      <Toast type={type} message={message} />
    </SnackbarContent>
  );
});
